import { useState, useEffect, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from 'axios';
import css from './index.module.css';

import SEO from "@components/seo";
import MainContent from "@components/content";
import useUserData from "@hooks/useUserData";

export default function AdmBlog() {
  const [blog, setBlog] = useState<any>([]);
  const navigate = useNavigate();
      
  useEffect(() => {
    axios.get(`${import.meta.env.VITE_API_ADM_URL}/blog`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + localStorage.getItem('authToken')
        }
      })
      .then(response  => {
        setBlog(response.data);
      })
      .catch(error => {
        setBlog([]);
      });
  }, []);

  return (
    <MainContent>    
      <SEO 
        title="Блог"
        description=""
        ogUrl="https://artcons.io/"
      />

      <div className={css.head}>
        <h1>Блог</h1>
        <Link to={`/admin/blog/new`} style={{ textDecoration: 'none' }}><i className="fi fi-rr-add"></i></Link>
      </div>

      <div className={css.table}>
          <div className={css.tableHeader}>
            <a>Название статьи</a>
          </div>

          <div className={css.tableBody}>
            {blog.map((item: any) => (
                <div className={css.tableDiv} onClick={() => navigate(`/admin/blog/${item.id}`)}>
                    <a>{item.name}</a>
                </div>
            ))}
          </div>
      </div>
    </MainContent>
  )
}